import { createContext, useCallback, useEffect, useState } from "react";
import useApi from "../hooks/useApi";
import { useTranslation } from "react-i18next";

export const WhiteLabelContext = createContext({});

export const WhiteLabelProvider = ({ children }) => {

    const { t } = useTranslation();

    const { defaultApiUrl, setBaseUrl, baseUrl } = useApi();

    const [theme, setTheme] = useState(null);

    const someUrl = new URL(window.location.href);
    const protocol = someUrl.protocol;
    const cleanBase = `${protocol}//${someUrl.hostname}`;

    const isWhiteLabel = cleanBase !== process.env.REACT_APP_BASE_URL;

    if (!defaultApiUrl) {
        console.log('Configure a URL da API');
    }

    useEffect(() => {

        const hostname = window.location.hostname;

        if (isWhiteLabel) {

            fetch(defaultApiUrl(`theme/${hostname}`))
                .then(res => res.json())
                .then(data => {
                    setTheme(data);
                    setBaseUrl(`${protocol}//${data.api_url}`);
                })
                .catch((err) => {
                    console.log(err)
                });

        }

    }, [isWhiteLabel, defaultApiUrl, setBaseUrl, protocol]);

    //console.log('theme', theme);

    const setInstColors = useCallback((color) => {
        document.documentElement.style.setProperty('--inst-color-dark', color);
        document.documentElement.style.setProperty('--inst-color-very-dark', 'color-mix(in srgb, var(--inst-color-dark) 70%, black)');
        document.documentElement.style.setProperty('--inst-color-default', 'color-mix(in srgb, var(--inst-color-dark) 60%, white)');
        document.documentElement.style.setProperty('--inst-color-light', 'color-mix(in srgb, var(--inst-color-dark) 30%, white)');
        document.documentElement.style.setProperty('--inst-color-very-light', 'color-mix(in srgb, var(--inst-color-dark) 10%, white)');
    }, []);

    if (!baseUrl) 
        return <div>{t("Host de API não configurado")}</div>;

    if (isWhiteLabel && !theme) //espera o thema carregar
        return <div>{t("Carregando...")}</div>;

    const appName = isWhiteLabel ? theme?.app_name : process.env.REACT_APP_NAME;
    const appPrimaryColor = isWhiteLabel ? theme?.app_primary_color : null;
    const favicon = isWhiteLabel ? `${baseUrl}/${theme?.favicon}` : '/logos/favicon.ico';
    const logo192 = isWhiteLabel ? `${baseUrl}/${theme?.logo_192}` : '/logos/logo192.png';
    const logoBlack = isWhiteLabel ? `${baseUrl}/${theme?.logo_black}` : '/logos/logo_black.png';
    const manifest = isWhiteLabel ? null : '/manifest.json';

    return (
        <WhiteLabelContext.Provider value={{ isWhiteLabel, appName, appPrimaryColor, favicon, logo192, logoBlack, manifest, setInstColors }}>
            {children}
        </WhiteLabelContext.Provider>
    );
};